$(document).ready(function(){
  $('.sidebar__collection-filter h4.toggle').click(function(){
    $(this).parents(".sidebar__collection-filter").find('.toggle_list').slideToggle( "slow" );
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');      
    }
  });
  
  var first_load_time = true;
  
  //  converting json to html for flavors
  $('body .flavor-drawer__item').on('click', function(ev){
    ev.preventDefault();
   console.log('hello');
    $(this).attr("target", "");
    $('.modal--close').trigger("click");
    $('#main-content .shopify-section').hide();
    $('#main-content .template-page--root').hide();
    $('#main-content .cart--root').hide();
    $('#shopify-section-flavor-data').show();
    
    var data_favor_id = $(this).attr('data-flavor-id');    
    var data = getPreloadedState(); 
    var falvor_slide_html = "";
    
    //console.log(data_favor_id);
    
    data.flavors.forEach(function(value, index) {
     // console.log(value);
      
      falvor_slide_html += '<div class="flavor-slide-block" data-flavor-block-id="'+value.id+'">' + '<div class="flavor-contents">' +
          '<div class="flavor-title">'+ value.name +'</div>' +
          '<div class="flavor-image">' + '<img src="'+ value.image.sources.master +'" />' + '</div>' +
          '<div class="flavor-description">' + value.description + '</div>' +
          '</div>' + '</div>';
      
      $('.flavor-data-section').removeClass('slick-initialized slick-slider');
      $('.flavor-data-section').html(falvor_slide_html);     
      
    });    
    
    //  flavor data section slider
    $(".flavor-data-section").slick({
      infinite: true,
      //lazyLoad: 'ondemand',
      dots: false,
      autoplay: false,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      fade: true,
    })
    .on({
      beforeChange: function(event, slick, currentSlide, nextSlide) {
        //console.log("before");
        $(".slick-slide", this).eq(currentSlide).addClass("previous-slide");
        //$(".slick-slide", this).eq(currentSlide).addClass("slide-fade-animation");
      },
      afterChange: function() {
        //console.log("after");
        $(".previous-slide", this).removeClass("previous-slide");
      }
    });
    
    $(".flavor-data-section .flavor-slide-block").each(function(index, element){
      
      var data_slick_flavor_id = $(element).attr('data-flavor-block-id');
      
      if(data_slick_flavor_id == data_favor_id){
        var slideIndex = $(this).data('slick-index');
        $('.flavor-data-section').slick('slickGoTo',slideIndex,false);
        
        if(first_load_time){
          var slick_active_height = $(this).outerHeight(true);
          var new_height = slick_active_height + 450; // increase 450px for first loading flavor

          $(this).parents('.flavor-data-section').addClass('slick-first-time');
          $(this).parents('.flavor-data-section').css({"height": new_height});
          
          first_load_time = false;
        } else {
          $(this).parents('.flavor-data-section').removeClass('slick-first-time');
          $(this).parents('.flavor-data-section').css({"height": 'auto'});
        }
        
      }
      
    });
    
    $(".flavor-data-section").find("button").on('click', function(){
      $(".flavor-data-section").removeClass('slick-first-time');
      $(".flavor-data-section").css({"height": 'auto'});
    });
    
    $('.flavor-data-section').on('mousedown', function(e){
      $(this).one('mouseup', function(e){
        $(this).off('mousemove');
        console.log('okay');
        $(".flavor-data-section").removeClass('slick-first-time');
        $(".flavor-data-section").css({"height": 'auto'});
      });      
    });
    
  });

  function getPreloadedState(){
    var e = document.querySelector("[data-preloaded-state]").innerHTML,
        t = JSON.parse(e);
    return (
      (t.flavors = t.flavors.filter(function (e) {
        return "dummy" !== e;
      })),
      t
    );
  }
                   
})

